import React, { useMemo, useState } from "react";
import { Helmet } from "react-helmet-async";
import {
  Box,
  Typography,
  Divider,
  Breadcrumbs,
  Link as MuiLink,
  TextField,
} from "@mui/material";
import { Link as RouterLink } from "react-router-dom";

import DataGridInfoAlert from "../../components/dataAdminGrid/InfoAlert";
import DataAdminGrid from "../../components/dataAdminGrid/DataAdminGrid";
import { ROUTES } from "../../constants";
import {
  PWS_CONTACTS_BASE_URL,
  COLUMNS,
  PWS_CONTACT_PK_FIELD,
} from "./pwsContactsConfig";

import { usePwsContactLookups } from "./usePwsContactLookups";

function PwsContactsPage() {
  // Even though we don't have lookups, we call the hook for consistency
  usePwsContactLookups();

  const [searchText, setSearchText] = useState("");

  const normalizedNeedle = searchText.trim().toLowerCase();

  const rowMatchesSearch = useMemo(() => {
    if (!normalizedNeedle) return () => true;

    return (row) => {
      if (row?.access_contact_ndx == null) return true;

      const searchable = [
        row?.access_contact_ndx,
        row?.contact,
        row?.last_name,
        row?.first_name,
        row?.phone,
        row?.mobile,
        row?.fax,
        row?.email,
        row?.address,
        row?.city,
        row?.state,
        row?.zip,
        row?.tceq_number,
        row?.tx_license_no,
        row?.user_id,
        row?.notes,
      ]
        .filter((v) => v !== undefined && v !== null)
        .join(" ")
        .toLowerCase();

      return searchable.includes(normalizedNeedle);
    };
  }, [normalizedNeedle]);

  // No column transformations needed since we don't have lookups
  // and role is hidden from the user
  const columns = COLUMNS;

  return (
    <Box>
      <Helmet title="Public Water System Contacts Management" />

      <Typography variant="h3" gutterBottom display="inline">
        Public Water System Contacts Management
      </Typography>

      <Breadcrumbs sx={{ mt: 4 }} aria-label="breadcrumb">
        <MuiLink component={RouterLink} to={ROUTES.LANDING}>
          Home
        </MuiLink>
        <Typography>PWS Contacts</Typography>
      </Breadcrumbs>

      <Divider sx={{ my: 6 }} />

      <DataGridInfoAlert title="Manage Public Water System contacts:" />

      <Box sx={{ display: "flex", alignItems: "center", mb: 2 }}>
        <TextField
          fullWidth
          size="small"
          label="Search"
          value={searchText}
          onChange={(e) => setSearchText(e.target.value)}
        />
      </Box>

      <DataAdminGrid
        baseUrl={PWS_CONTACTS_BASE_URL}
        columns={columns}
        primaryKeyField={PWS_CONTACT_PK_FIELD}
        rowFilter={rowMatchesSearch}
      />
    </Box>
  );
}

export default PwsContactsPage;
